import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { animations } from "helpers/animations";
import makeAnimated from "react-select/animated";
import { useScrollTop } from "hooks/useScrollTop";
//Mui
import {
    FormControl,
    FormLabel,
    Grid,
    TextField,
    InputAdornment,
} from "@mui/material";
import { useForm } from "hooks/useForm";
import CancelIcon from "@mui/icons-material/Cancel";

//Component
import { SelectComponent } from "components/SelectMenu/SelectComponent";

import RegularButton from "components/CustomButtons/Button";
import { MultiSelect } from "components/MultiSelect/MultiSelect";

//redux
import {
    itemsRequests,
    setItemSnackbar,
    removeItemToUpdate
} from "redux/actions/integrations/itemsActions";


const animatedComponents = makeAnimated();

export const NewItemForm = (props) => {
    const {
        onClose,
        initialValues,
        fieldValidations,
        itemNumbers,
        handleCloseSnackbar,
        idUser,
        itemsAdd,
        setItemsAdd,
        count,
        modalEdit,
        handleSaveItemUpdate,
        handleChange,
        isInventariable,
        mapCategories,
        mapClasses,
        handleDeleteItem,
        deleteLastItem,
        setDeleteLastItem,
    } = props;
    const dispatch = useDispatch();
    const ref = useScrollTop()

    const {
        inputValues,
        handleInputOnChange,
        fieldErrors,
        runValidates,
        handleNewValues
    } = useForm(initialValues, fieldValidations);

    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [showNewForm, setShowNewForm] = useState(false);

    const {
        item,
        originalItems,
        newItemMode
    } = useSelector(({ items }) => items);
    const { stationsList } = useSelector(({ companiesItems }) => companiesItems);

    const [stationsValues, setStationValues] = useState(stationsList.map(station => {
        return item?.organizations && Object.keys(item?.organizations).find(key => key === station?.id) ?
            { value: station.id, label: station.name, oraclePrice: item?.organizations[station.id]?.listPrice } :
            { value: station.id, label: station.name };
    }))
    const [masterPrice, setMasterPrice] = useState(item?.masterPrice)

    const {
        description,
        application,
        brand,
        price,
        partNumber,
        uom,
        idStations,
        inventoriable,
        idCategory,
        idClass,
    } = inputValues;

    const handleChangeStation = event => {
        handleNewValues({
            ...inputValues,
            idStations: event,
        });
        setItemsAdd(Object.keys(itemsAdd).map(key => {
            if (key === count.toString()) {
                itemsAdd[count] = { ...inputValues, idStations: event }
            }
            return itemsAdd[key]
        }))
        setSelectedCompanies(event);
    }

    const handleNewForm = () => {
        const error = runValidates();
        if (error) return;
        if (Object.keys(idStations).length === 0) {
            dispatch(setItemSnackbar("No hay plantas seleccionadas"))
            return;
        }
        handleChange()
        setShowNewForm(true);
    }

    const handleSubmit = () => {
        const error = runValidates();
        if (error) return;
        if (Object.keys(idStations).length === 0) {
            dispatch(setItemSnackbar("No hay plantas seleccionadas"))
            return;
        }
        if (modalEdit) {
            const editForm = Object.keys(itemsAdd).map(key => {
                return {
                    description: itemsAdd[key].description.slice(0, 67) + (itemsAdd[key].description.length > 67 ? "..." : ""),
                    itemId: itemsAdd[key].itemId,
                    itemNumber: itemsAdd[key].itemNumber,
                    price: parseFloat(itemsAdd[key].price),
                    stations: Object.values(itemsAdd[key].idStations).map(e => {
                        return e?.oraclePrice ?
                            { id: e.value, oraclePrice: e?.oraclePrice } :
                            { id: e.value, oraclePrice: originalItems[key]?.masterPrice ? originalItems[key]?.masterPrice : masterPrice }
                    }),
                }
            })
            const request = {
                type: 'UPDATE',
                idUser: idUser,
                items: editForm,
            }
            dispatch(itemsRequests(request));
            onClose()
        }
        else {
            const createForm = Object.values(itemsAdd).map(itemCreate => {
                return {
                    description: itemCreate.description,
                    application: itemCreate.application,
                    brand: itemCreate.brand,
                    price: parseFloat(itemCreate.price),
                    partNumber: itemCreate.partNumber,
                    uom: itemCreate.uom,
                    stations: Object.values(itemCreate.idStations).map((station) => station.value),
                    inventoriable: parseInt(itemCreate.inventoriable),
                    idCategory: itemCreate.idCategory,
                    idClass: itemCreate.idClass,
                }
            })
            const request = {
                type: 'CREATE',
                idUser: idUser,
                items: createForm,
            }
            dispatch(itemsRequests(request));
            onClose()
        }
    };

    const handleInputChange = (e) => {
        handleInputOnChange(e)
        setItemsAdd(Object.keys(itemsAdd).map(key => {
            if (key === count.toString()) {
                itemsAdd[count] = { ...inputValues, [e.target.name]: e.target.value }
            }
            return itemsAdd[key]
        }))
    }

    const handleDeleteToSave = () => {
        if (itemsAdd[count + 1]) {
            setSelectedCompanies(itemsAdd[count + 1]?.idStations)
            handleNewValues(itemsAdd[count + 1]);
            setDeleteLastItem(true)
        }
        else {
            handleDeleteItem()
        }
        if (modalEdit) {
            dispatch(removeItemToUpdate(inputValues.itemNumber))
            setTimeout(() => {
                setItemsAdd(Object.values(itemsAdd).filter(value => value.itemNumber !== inputValues.itemNumber))
            }, 500);
        }
        else {
            setTimeout(() => {
                setItemsAdd(Object.values(itemsAdd).filter(value => value?.description !== inputValues?.description))
            }, 500);
        }

    }

    const handleDeleteNewItem = () => {
        setShowNewForm(false)
    }

    const handleSaveToUpdate = () => {
        if (selectedCompanies.length > 0) {
            handleSaveItemUpdate()
        }
        else {
            dispatch(setItemSnackbar("No hay plantas seleccionadas"))
        }
    }
    useEffect(() => {
        if (deleteLastItem && newItemMode &&itemsAdd[count + 1]) {
            setSelectedCompanies(itemsAdd[count + 1]?.idStations)
            handleNewValues(itemsAdd[count + 1]);
        }
        if (deleteLastItem && modalEdit && !itemsAdd[count + 1]?.itemNumber) {
            setDeleteLastItem(false)
            handleDeleteItem()
        }
        else if (deleteLastItem && newItemMode && !itemsAdd[count + 1]?.inventoriable) {
            setDeleteLastItem(false)
            handleDeleteItem()
        }
        

    }, [deleteLastItem]);

    useEffect(() => {
        if (modalEdit && Object.keys(itemsAdd).length > 0) {
            Object.keys(itemsAdd).map(key => {
                if (key === count.toString()) {
                    const newValues = {
                        itemId: itemsAdd[key]?.itemId,
                        itemNumber: itemsAdd[key]?.itemNumber,
                        description: itemsAdd[key]?.description,
                        price: itemsAdd[key]?.price,
                        idStations: itemsAdd[key]?.idStations
                    };
                    setSelectedCompanies(itemsAdd[key]?.idStations);

                    if (Object.keys(itemsAdd).length > (count + 1)) {
                        setMasterPrice(originalItems[count]?.masterPrice)
                        setStationValues(stationsList.map(station => {
                            return Object.keys(originalItems[count]?.organizations).find(key => key === station?.id) ?
                                { value: station.id, label: station.name, oraclePrice: originalItems[count]?.organizations[station.id]?.listPrice } :
                                { value: station.id, label: station.name };
                        }))
                    }
        
                    handleNewValues(newValues);
                }
            })

            Object.keys(itemsAdd).length > (count + 1) && setShowNewForm(true);
        }
    }, [itemsAdd]);

    return (
        <FormControl fullWidth className={animations.fadeIn} >
            <Grid container spacing={1} style={{ marginTop: "2rem" }} classes={{
                root: {
                    ref: ref
                }
            }}>
                <Grid container justifyContent="flex-end">
                    <RegularButton
                        color="transparent"
                        round
                        justIcon
                        onClick={handleDeleteToSave}
                        tooltip="Eliminar"
                        style={{
                            bottom: 10,
                            right: 10,
                        }}
                    >
                        <CancelIcon style={{ color: "#f6685e" }} />
                    </RegularButton>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Descripción"
                        name="description"
                        value={description}
                        onChange={handleInputChange}
                        variant="outlined"
                        autoFocus={true}
                        error={fieldErrors.description}
                        helperText={fieldErrors.description || ""}
                        disabled={modalEdit ? true : false}
                    />
                </Grid>
                {!modalEdit ?
                    <>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                fullWidth
                                label="Aplicación"
                                name="application"
                                value={application}
                                onChange={handleInputChange}
                                variant="outlined"
                                error={fieldErrors.application}
                                helperText={fieldErrors.application || ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Marca"
                                        name="brand"
                                        value={brand}
                                        onChange={handleInputChange}
                                        variant="outlined"
                                        error={!!fieldErrors.brand}
                                        helperText={fieldErrors.brand}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Precio unitario"
                                        name="price"
                                        value={price}
                                        onChange={handleInputChange}
                                        variant="outlined"
                                        error={!!fieldErrors.price}
                                        helperText={fieldErrors.price}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">$</InputAdornment>
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Número de parte"
                                        name="partNumber"
                                        value={partNumber}
                                        onChange={handleInputChange}
                                        variant="outlined"
                                        error={!!fieldErrors.partNumber}
                                        helperText={fieldErrors.partNumber}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <SelectComponent
                                label="Unidad de medida"
                                name="uom"
                                value={uom}
                                onChange={handleInputChange}
                                options={itemNumbers}
                                defaultValue="Unidad de medida"
                                error={fieldErrors.uom}
                                helperText={fieldErrors.uom || ""}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <SelectComponent
                                label="Inventariable"
                                name="inventoriable"
                                value={inventoriable}
                                onChange={handleInputChange}
                                options={isInventariable}
                                defaultValue="Inventariable"
                                error={fieldErrors.inventoriable}
                                helperText={fieldErrors.inventoriable || ""}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <SelectComponent
                                label="Categoría"
                                name="idCategory"
                                value={idCategory}
                                onChange={handleInputChange}
                                options={mapCategories}
                                defaultValue="Categoría"
                                error={fieldErrors.idCategory}
                                helperText={fieldErrors.idCategory || ""}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <SelectComponent
                                label="Clase"
                                name="idClass"
                                value={idClass}
                                onChange={handleInputChange}
                                options={mapClasses}
                                defaultValue="Clase"
                                error={fieldErrors.idClass}
                                helperText={fieldErrors.idClass || ""}
                            />
                        </Grid>
                    </>
                    : <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            label="Precio unitario"
                            name="price"
                            value={price}
                            onChange={handleInputChange}
                            variant="outlined"
                            error={!!fieldErrors.price}
                            helperText={fieldErrors.price}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>
                            }}
                        />
                    </Grid>
                }
                <Grid item xs={12}>
                    <FormLabel
                        style={{ backgroundColor: 'white', padding: '5px 10px', borderRadius: 4, }}
                    >
                        Plantas
                    </FormLabel>
                    <MultiSelect
                        placeholder="Plantas.."
                        name="stations"
                        value={selectedCompanies}
                        components={animatedComponents}
                        options={stationsValues}
                        onChange={handleChangeStation}
                        className="list-select__container "
                        classNamePrefix="select"
                        allLabel="Todas las plantas"
                    />
                </Grid>

                {!showNewForm &&
                    <Grid item xs={12}
                        style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
                    >
                        {modalEdit ?
                            <RegularButton color="info" onClick={handleSaveToUpdate}>
                                Guardar sin solicitud
                            </RegularButton> :
                            <RegularButton color="info" onClick={handleNewForm}>
                                Agregar otro Artículo
                            </RegularButton>
                        }
                        <RegularButton color="success" onClick={handleSubmit}>
                            {modalEdit ? "Actualizar Producto" : `Alta de Artículo`}
                        </RegularButton>
                    </Grid>
                }
            </Grid>
            {
                showNewForm &&
                <NewItemForm
                    onClose={onClose}
                    initialValues={initialValues}
                    fieldValidations={fieldValidations}
                    itemNumbers={itemNumbers}
                    handleCloseSnackbar={handleCloseSnackbar}
                    idUser={idUser}
                    itemsAdd={itemsAdd}
                    setItemsAdd={setItemsAdd}
                    count={count + 1}
                    modalEdit={modalEdit}
                    handleSaveItemUpdate={handleSaveItemUpdate}
                    handleChange={handleChange}
                    isInventariable={isInventariable}
                    mapCategories={mapCategories}
                    mapClasses={mapClasses}
                    handleDeleteItem={handleDeleteNewItem}
                    deleteLastItem={deleteLastItem}
                    setDeleteLastItem={setDeleteLastItem}
                />
            }
        </FormControl>
    );
};
